"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ApptTime = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _intl = require("@kyruus/intl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _messages = _interopRequireDefault(require("../../../lib/messages"));
var _utils = require("../../../lib/utils");
var _styles = require("./styles");
const formatApptTime = appointment => (0, _moment.default)(appointment.start_datetime).format('dddd, MMMM DD, YYYY [at] h:mm A');
const formatArrivalTime = appointment => (0, _moment.default)(appointment.arrival_datetime).format('h:mm A');
const ApptTime = _ref => {
  let {
    appointment
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_styles.ApptDetailsRow, null, /*#__PURE__*/_react.default.createElement("p", null, formatApptTime(appointment)), appointment.arrival_datetime && formatArrivalTime && !(0, _utils.hasAnyVideoPhoneAppt)(appointment.visit_method) && /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, (0, _extends2.default)({}, _messages.default.apptArrivalTime, {
    values: {
      arrivalTime: formatArrivalTime(appointment)
    }
  }))));
};
exports.ApptTime = ApptTime;
ApptTime.propTypes = {
  appointment: _propTypes.default.object.isRequired
};
ApptTime.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ApptTime",
  "props": {
    "appointment": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": true
    }
  }
};